// extracted by mini-css-extract-plugin
export default {"container":"Contents_container__TSQfJ"};